export enum PrepActionTypes {
  SET_BCL_SELECTION = "SET_BCL_SELECTION",
  SET_PREP_REQUEST = "SET_PREP_REQUEST",
  SET_PREP_JOB = "SET_PREP_JOB",
  SET_FLOOR_LOADED_CONTAINER_DETAILS = "SET_FLOOR_LOADED_CONTAINER_DETAILS",
  SET_PREP_CREATION_SOURCE = "SET_PREP_CREATION_SOURCE",
}
